import { Component, Input, OnInit } from '@angular/core';
import { BracketService } from './bracket.service';

@Component({
  selector: 'lib-bracket',
  templateUrl: 'bracket.component.html',
  styleUrls: ['bracket.component.scss'],
})
export class BracketComponent implements OnInit {
  rounds: number = 0;
  roundNames: string[] = [];
  highestPlayInMatches: number = 0;

  @Input() set teams(val: number) {
    const calc = this.bracketService.calculateBracket(val);
    const bracket = this.bracketService.calculateTree(calc);
    this.matches = bracket;
    this.rounds = calc.rounds;
    this.roundNames = this.bracketService.getRounds(calc.rounds);
    this.highestPlayInMatches = bracket.highestPlayInMatchCount;
  }

  constructor(private bracketService: BracketService) {}

  getLineClass(match: any, sibling: number, siblings: any[]) {
    if (match.fake) return;

    const realSiblings = siblings.filter((p) => !p.fake);
    if (this.highestPlayInMatches == 2 && sibling === 0) {
      return 'first-bracket-line';
    }
    if (realSiblings.length === 1) {
      return 'straight-bracket-line';
    }

    if (sibling === 1) {
      return 'second-bracket-line';
    }

    if (sibling === 0) {
      return 'first-bracket-line';
    }
  }

  matches: any = {
    root: {
      match: undefined,
      previous: [],
    },
  };

  ngOnInit(): void {}
}
